<template>
  <div class="complain text-left">
    <p class="text-2xl font-bold mb-6 text-neutral-700">Ajukan Komplain</p>
    <div class="mb-6">
      <TextField borderEnabled type="text" v-model="payloads.name" label="Nama Lengkap" placeholder="Masukan nama lengkap" :error="errors['name']" />
    </div>
    <div class="mb-6">
      <TextField borderEnabled type="text" v-model="payloads.email" label="Alamat Email" placeholder="Masukan alamat email" :error="errors['email']" />
    </div>
    <div class="mb-6">
      <TextField borderEnabled type="number" v-model="payloads.phone_number" label="No. Handphone" placeholder="Masukan nomor handphone" :error="errors['phone_number']" />
    </div>
    <div class="mb-6">
      <Textarea borderEnabled v-model="payloads.comment" label="Keluhan" placeholder="Masukan keluhan" :error="errors['comment']" />
    </div>
    <div class="mb-6">
      <label class="text-sm text-neutral-700 font-medium mb-3 inline-block">Upload Photo (optional)</label>
      <div class="flex items-start gap-3">
        <div class="upload-image-1">
          <div class="w-20 h-20" v-if="!images.proof_url_1">
            <label for="proof-image-1" class="text-primary-500 bg-neutral-200 flex justify-center items-center w-full h-full cursor-pointer">
              <Upload />
            </label>
            <input type="file" id="proof-image-1" accept=".jpg, .png, .jpeg" class="absolute -z-1 opacity-0" @change="handleFileSelect($event, 'complain', 'proof_url_1')" />
          </div>
          <div class="w-40" v-else>
            <img :src="images.proof_url_1" />
          </div>
        </div>
        <div class="upload-image-2">
          <div class="w-20 h-20" v-if="!images.proof_url_2">
            <label for="proof-image-2" class="text-primary-500 bg-neutral-200 flex justify-center items-center w-full h-full cursor-pointer">
              <Upload />
            </label>
            <input type="file" id="proof-image-2" accept=".jpg, .png, .jpeg" class="absolute -z-1 opacity-0" @change="handleFileSelect($event, 'complain', 'proof_url_2')" />
          </div>
          <div class="w-40" v-else>
            <img :src="images.proof_url_2" />
          </div>
        </div>
      </div>
    </div>
    <div class="mb-6 flex items-center gap-4 w-full">
      <div class="text-sm w-full p-4 flex items-center gap-3 bg-secondary-100 text-neutral-700 rounded-md">
        <span class="flex-shrink-0"><Info width="24" height="24" color="neutral-700"/></span>
        LinkNau adalah layanan pihak ke-3, kami akan membantu menyampaikan keluhan terkait kendala paket kiriman. Pihak logistik akan menghubungi pegirimin via email ataupun telepon.
      </div>
    </div>
    <div class="flex justify-end gap-4 mb-2">
      <Button buttonText="Batal" type="secondary" @action="closeModal()" :size="isMobile ? 'full' : 'regular'" />
      <Button buttonText="Kirim" type="primary" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'
const CONFIG = {
  name: 'Nama lengkap',
  email: 'Email',
  phone_number: 'No. handphone',
  comment: 'Keluhan'
}
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    Upload: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Upload'),
    Button: () => import(/* webpackChunkName: "Button" */ '@/components/Forms/Button'),
    Info: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Info')
  },
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      payloads: {
        name: null,
        email: null,
        phone_number: null,
        comment: null
      },
      images: {
        proof_url_1: '',
        proof_url_2: ''
      },
      errors: []
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile'])
  },
  methods: {
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading', 'uploadImage']),
    ...mapActions('order', ['complain']),
    handleFileSelect(event, purpose, target) {
      this.showLoading()
      const file = event.target.files[0]
      let imageData = new FormData()
      imageData.append('image', file)
      imageData.append('file_purpose', purpose)
      this.uploadImage({ payloads: imageData }).then(res => {
        this.hideLoading()
        this.images[target] = res.file_url
      })
    },
    closeModal() {
      this.$emit('close')
    },
    submit() {
      if (this.validForm()) {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (!regex.test(this.payloads.email)) {
          this.errors['email'] = 'Format email tidak valid!'
          return
        }
        this.showLoading()
        const constructedPayload = {
          name: this.payloads.name,
          email: this.payloads.email,
          phone_number: this.payloads.phone_number,
          proof_url_1: this.images.proof_url_1,
          proof_url_2: this.images.proof_url_2,
          comment: this.payloads.comment
        }
        this.complain({
          orderId: this.orderId,
          payloads: constructedPayload
        })
          .then(() => {
            this.closeModal()
            this.hideLoading()
            this.setToast({
              options: { type: 'success', duration: 2000, primaryText: 'Komplain berhasil dikirimkan', secondaryText: '', callback: () => {} }
            })
          })
          .catch(() => {
            this.closeModal()
            this.hideLoading()
            this.setToast({
              options: { type: 'danger', duration: 4000, primaryText: 'Gagal mengirimkan komplain, terjadi kesalahan pada sistem!', secondaryText: 'Silakan coba lagi.', callback: () => {} }
            })
          })
      }
    },
    validForm() {
      const error = isNotEmptyError(this.payloads)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    }
  }
}
</script>
